import React, { FunctionComponent } from "react";

export const PageFooter: FunctionComponent = React.memo(({ children }) => {
	return <footer className="page-footer">{children}</footer>;
});
